import { Box } from '@mui/material';
import ImageOutlinedIcon from '@mui/icons-material/ImageOutlined';
import { useBundleProductImageSrc } from './useBundleProductImageSrc';

interface Props {
  imageKey: string;
  assetUrl: string;
  alt: string;
  onClick?: () => void;
}

const BundleProductThumbnail = ({
  imageKey,
  assetUrl,
  alt,
  onClick,
}: Props) => {
  const { src, failed, handleError } = useBundleProductImageSrc(
    imageKey,
    assetUrl
  );

  if (!imageKey || failed || !src) {
    return (
      <Box
        sx={{
          width: 48,
          height: 48,
          borderRadius: 1,
          bgcolor: 'grey.200',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          mx: 'auto',
        }}
      >
        <ImageOutlinedIcon sx={{ color: 'grey.500' }} />
      </Box>
    );
  }

  return (
    <Box
      component='img'
      src={src}
      alt={alt}
      onClick={onClick}
      onError={handleError}
      sx={{
        width: 48,
        height: 48,
        borderRadius: 1,
        mx: 'auto',
        display: 'block',
        objectFit: 'contain',
        cursor: onClick ? 'pointer' : 'default',
      }}
    />
  );
};

export default BundleProductThumbnail;
